import {
  MessageTemplate,
  Page,
  RootDispatch,
  RootGetState,
  FamilyMemberSms,
  FamilyMember
} from "../types";
import history from "../../history";
import flash from "../flash/actions";
import { get, post } from "../../utils/fetch";
import { Patient } from "../patient/types";

export type Action =
  | { type: "messageFamily/getFamilyLibrary-started" }
  | { type: "messageFamily/getFamilyLibrary-success"; messageTemplateList: Page<MessageTemplate> }
  | { type: "messageFamily/getFamilyLibrary-failure"; errorMessage: string }
  | { type: "messageFamily/sendUnsecureMessage-started" }
  | { type: "messageFamily/sendUnsecureMessage-success" }
  | { type: "messageFamily/sendUnsecureMessage-failure"; errorMessage: string }
  | { type: "messageFamily/sendSecureMessage-started" }
  | { type: "messageFamily/sendSecureMessage-success" }
  | { type: "messageFamily/sendSecureMessage-failure"; errorMessage: string };

export const sendUnsecureMessage = (
  patient: Patient,
  message: string,
  familyMemberIds: string[]
) => async (dispatch: RootDispatch, getState: RootGetState) => {
  dispatch({
    type: "messageFamily/sendUnsecureMessage-started"
  });

  const url =
    "/api/organization/" +
    getState().orgs.currentOrganization?.id +
    "/patients/" +
    patient.id +
    "/sendSmsBatch/";

  const body = { messageBody: message, familyMemberIds: familyMemberIds };

  const resp = await post(url, body);

  if (resp.error) {
    dispatch({
      type: "messageFamily/sendUnsecureMessage-failure",
      errorMessage: resp.error.message
    });
    dispatch(flash("Error sending SMS: " + resp.error.message, "error"));
  } else if (resp.data) {
    dispatch({
      type: "messageFamily/sendUnsecureMessage-success"
    });
    dispatch(
      flash(
        "SMS message(s) have been sent to " +
          familyMemberIds.length +
          " family members of " +
          patient.givenName +
          " " +
          patient.familyName,
        "info"
      )
    );
    history.goBack();
  } else {
    // TODO Logging
  }
};

export const sendSecureMessage = (
  patient: Patient,
  familyMembers: FamilyMemberSms[],
  message?: string,
  attachments?: string[]
) => async (dispatch: RootDispatch, getState: RootGetState) => {
  dispatch({
    type: "messageFamily/sendSecureMessage-started"
  });

  const memberErrors: FamilyMember[] = [];
  const body = { subject: "Secure Message", messageBody: message, attachments: attachments };

  let url: string;

  familyMembers.forEach(async familyMember => {
    url =
      "/api/organization/" +
      getState().orgs.currentOrganization?.id +
      "/patients/" +
      patient.id +
      "/familyMembers/" +
      familyMember.id +
      "/sendSecureMessage/";

    const resp = await post(url, body);
    if (resp.error) {
      memberErrors.push(familyMember);
    }
  });

  if (memberErrors.length > 0) {
    const errorMessage =
      "The following users were NOT send a secure message. " +
      memberErrors.map(x => (x.name ? x.name : x.phone)).join(", ");
    dispatch({
      type: "messageFamily/sendSecureMessage-failure",
      errorMessage: errorMessage
    });
    dispatch(flash("Error sending secure messages. Please review."));
  } else {
    dispatch({
      type: "messageFamily/sendSecureMessage-success"
    });
    dispatch(
      flash(
        "A secure message has been sent to each included family member for " +
          patient.givenName +
          " " +
          patient.familyName,
        "info"
      )
    );
    history.goBack();
  }
};

export const getFamilyMessageTemplateList = () => async (
  dispatch: RootDispatch,
  getState: RootGetState
) => {
  dispatch({
    type: "messageFamily/getFamilyLibrary-started"
  });

  const url =
    "/api/organization/" +
    getState().orgs.currentOrganization?.id +
    "/messageTemplates/?type=family&page_size=9999";

  const resp = await get<Page<MessageTemplate>>(url);

  if (resp.error) {
    dispatch({
      type: "messageFamily/getFamilyLibrary-failure",
      errorMessage: resp.error.message
    });
  } else if (resp.data) {
    dispatch({
      type: "messageFamily/getFamilyLibrary-success",
      messageTemplateList: resp.data
    });
  } else {
    // TODO logging
  }
};
